import { Box, Car, Home, Store, Package } from "lucide-react";
import { fmtMoney } from "./crmShared";

/** Récap des lots d'une transaction, groupé par bloc (iter215) — partagé par les fiches devis / réservation / vente. */
const TYPE_ICON = [
  [/appart|f\d|studio|duplex/i, Home, "#7F77DD"],
  [/d[ée]barras|cave|cellier|box/i, Box, "#2A9A7A"],
  [/parking|garage|stationnement/i, Car, "#378ADD"],
  [/local|commerce|boutique|bureau/i, Store, "#E0822E"],
];
export const typeIconFor = (type) => TYPE_ICON.find(([rx]) => rx.test(type || ""))?.slice(1) || [Package, "#9a9aa2"];
const cmp = (a, b) => String(a || "").localeCompare(String(b || ""), "fr", { numeric: true });

export default function LotsByBlock({ lots = [], testId = "tx-lots-by-block", renderChip = null }) {
  const groups = new Map();
  for (const l of lots) { const k = l.block_name || "—"; if (!groups.has(k)) groups.set(k, []); groups.get(k).push(l); }
  const blocks = [...groups.keys()].sort(cmp);
  if (!lots.length) return null;
  return (
    <div className="flex flex-col" style={{ gap: 6 }} data-testid={testId}>
      {blocks.map((b) => (
        <div key={b} className="flex items-center flex-wrap" style={{ gap: 6 }} data-testid={`${testId}-${b}`}>
          <span style={{ fontSize: 11, color: "#9a9aa2", width: 48, flexShrink: 0 }}>Bloc {b}</span>
          {groups.get(b).sort((x, y) => cmp(x.numero, y.numero)).map((l) => { const [I, color] = typeIconFor(l.type); const chip = (
            <span key={l.id} className="inline-flex items-center" style={{ gap: 6, background: "#0e0e10", border: "0.5px solid #26262b", borderRadius: 7, padding: "5px 10px" }} data-testid={`${testId}-lot-${l.id}`}>
              <I size={13} style={{ color, flexShrink: 0 }} />
              <span style={{ fontSize: 12, color: "#f4f4f5" }}>N° {l.numero || "—"}</span>
              <span style={{ fontSize: 10, color: "#9a9aa2" }}>{fmtMoney(l.price_ttc ?? l.prix_ttc)}</span>
            </span>);
            return renderChip ? renderChip(l, chip) : chip; })}
        </div>
      ))}
    </div>
  );
}
